import styled from "styled-components";

const Styled = styled.div`
    display: grid;
    gap: 2px;
    grid-auto-flow: column;
    grid-auto-columns: minmax(min-content, 1fr);

    button {
        background: transparent;
        border: none;
        border-radius: 2px;
        color: #000a;
        font-family: inherit;
        font-size: 1rem;
        padding: 6px 12px;

        &:disabled {
            opacity: .4;
        }

        &:enabled {
            &:hover {
                background: #0001;
                color: #000;
                cursor: pointer;
            }

            &[data-selected="true"]:only-child {
                cursor: default;
            }
        }

        &[data-selected="true"][data-selected="true"] {
            background: #001d;
            color: #fff;
        }
    }
`;

interface ISwitchProps {
    disabled?: boolean
    onChange: (value: unknown) => void
    options: {
        label: string
        value: unknown
    }[]
    value: unknown
}

export default function Switch(props: ISwitchProps) {
    const { disabled, onChange, options, value, ...restProps } = props;
    return (
        <Styled { ...restProps }>
            {
                options.map(
                    (option) => (
                        <button
                            data-selected={ value === option.value }
                            disabled={ disabled }
                            key={ option.value }
                            onClick={ () => onChange(option.value) }
                        >
                            { option.label }
                        </button>
                    )
                )
            }
        </Styled>
    );
}
